/**
 * MIO — Score helpers: SINGLE SOURCE OF TRUTH para apresentação de pontuações.
 *
 * Regra: o backend é autoritativo. O frontend apenas formata/arredonda
 * de forma consistente em todos os locais (Painel, Portal, PDF, Comparação,
 * Evolução). NUNCA recalcular score localmente.
 *
 * Toda apresentação visível deve passar por `formatScore()`.
 */

/** Arredonda ao inteiro mais próximo. Mantém `null`/`undefined`/inválidos como `null`. */
export function roundScore(value) {
  if (value === null || value === undefined) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round(n);
}

/** Formata para apresentação: "84" / "—" se inválido. */
export function formatScore(value) {
  const r = roundScore(value);
  return r == null ? "—" : String(r);
}

/** Calcula delta entre dois scores arredondados (mesma fonte de verdade). */
export function scoreDelta(curr, prev) {
  const c = roundScore(curr);
  const p = roundScore(prev);
  if (c == null || p == null) return null;
  return c - p;
}
